import { render, staticRenderFns } from "./VInventoryItemReturnModal.vue?vue&type=template&id=0760fdd4"
import script from "./VInventoryItemReturnModal.vue?vue&type=script&lang=js"
export * from "./VInventoryItemReturnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports